<template>
    <v-card class="text-center scroll container automargin" 
    flat>
        <div class="text-center">
            <v-btn
            v-if="!showPdf"
            color="primary"
            outlined
            small
            fixed        
            class="btn_back"
            v-on:click="closeModelViewer"
            >back to list
            </v-btn> 
        </div>
        <h3>{{title}}</h3>
        <v-container >
            <v-row v-if="ecu_model">
                <v-tabs
                    v-model="tabsInputsEcu"
                    background-color="transparent"
                    color="primary"
                    grow
                >
                    <v-tab
                    v-for="item in ecuInputTabs"
                    :key="item.name"
                    >
                    {{ item.name }}
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabsInputsEcu">
                    <v-tab-item
                        v-for="tab in ecuInputTabs"
                        :key="tab.name"
                    >
                        <v-card class="text-center scroll" flat v-show="tab.tabId=='1'">
                            <v-row>
                                <v-col cols="12" sm="6">                        
                                <v-combobox
                                    v-model="selected_ecu_macro_scenarios"
                                    :items="ecu_macro_scenarios"
                                    item-text="value"
                                    item-value="code"
                                    @change="selectRow"
                                    label="Macro Scenario Selection"
                                ></v-combobox>
                                </v-col>
                                <v-col cols="12" sm="6">
                                <v-combobox
                                    v-model="selected_ecu_oil_scenarios"
                                    :items="ecu_oil_scenarios"
                                    item-text="value"
                                    item-value="code"
                                    @change="selectRow"
                                    label="Oil Price Scenario Selection"
                                ></v-combobox>
                                </v-col>
                            </v-row>
                            <div>
                                <img v-bind:src="image_inputs_macro"/>
                            </div>
                        </v-card>
                        <v-card class="text-center scroll" flat v-show="tab.tabId=='2'">
                            <v-row>
                                <v-col v-for="(item,key) in ecu_debt_inputs_header" class="class_header" :key="key" :cols="key === 1 ? 3 : undefined" >
                                    <h5>{{item}}</h5>
                                </v-col>
                            </v-row>
                            <v-row v-for="(item,key) in ecu_debt_inputs" :key="key"  no-gutters>
                                <v-col v-for="(subitem,subkey) in item" :key="subkey" :cols="typeField(subkey)==='n'||typeField(subkey)==='t' ? 3 : undefined">
                                    <template v-if="typeField(subkey)==='n'">
                                        <div class="cell_left_pad" style="height: 20px; font-size: 11px !important;">{{subitem}}</div>
                                    </template>
                                    <template v-else-if="typeField(subkey)==='p'">
                                        <v-text-field @input="selectRow" v-model="item[subkey]" class="ma-0 pa-0 pr-3 pl-3 cell" style="height: 20px; font-size: 11px !important;" height="15px" suffix=% />
                                    </template>		
                                    <template v-else-if="typeField(subkey)==='i'">
                                        <v-text-field @input="selectRow" v-model="item[subkey]" class="ma-0 pa-0 pr-3 pl-3 cell" style="height: 20px; font-size: 11px !important;" height="15px"/>
                                    </template>		
                                    <template v-else-if="typeField(subkey)==='c'">
                                        <div class="cell" style="height: 20px; font-size: 11px !important;">{{calculate_total(item)}}</div>
                                    </template>
                                    <template v-else-if="typeField(subkey)==='t'">    
                                        <div class="cell_left" style="height: 20px; font-size: 11px !important;">{{subitem}}</div>
                                    </template>
                                    <template v-else-if="typeField(subkey)==='l'">   
                                        <div class="cell" style="height: 20px; font-size: 11px !important;">{{subitem}}</div>
                                    </template>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card class="text-center scroll" flat v-show="tab.tabId=='3'">
                            <v-row>
                                <v-col v-for="(item,key) in ecu_refinancing_inputs_header" class="class_header" :key="key" :cols="key === 1 ? 2 : undefined" >
                                    <h5>{{item}}</h5>
                                </v-col>
                            </v-row>
                            <v-row v-for="(item,key) in ecu_refinancing_inputs" :key="key"  no-gutters>
                                <v-col v-for="(subitem,subkey) in item" :key="subkey" :cols="typeField(subkey)==='n'||typeField(subkey)==='t' ? 2 : undefined">
                                    <template v-if="typeField(subkey)==='n'">
                                        <div class="cell_left_pad" style="height: 20px; font-size: 11px !important;">{{subitem}}</div>
                                    </template>
                                    <template v-else-if="typeField(subkey)==='p'">
                                        <v-text-field @input="selectRow" v-model="item[subkey]" class="ma-0 pa-0 pr-3 pl-3 cell" style="height: 20px; font-size: 11px !important;" height="15px" suffix=% />
                                    </template>		
                                    <template v-else-if="typeField(subkey)==='i'">
                                        <v-text-field @input="selectRow" v-model="item[subkey]" class="ma-0 pa-0 pr-3 pl-3 cell" style="height: 20px; font-size: 11px !important;" height="15px"/>
                                    </template>
                                    <template v-else-if="typeField(subkey)==='t'">    
                                        <div class="cell_left" style="height: 20px; font-size: 11px !important;">{{subitem}}</div>
                                    </template>
                                    <template v-else-if="typeField(subkey)==='l'">   
                                        <div class="cell" style="height: 20px; font-size: 11px !important;">{{subitem}}</div>
                                    </template>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-row>
            <v-row v-if="arg_model">
                <v-col cols="12" sm="6">                        
                <v-combobox
                    v-model="selected_arg_making_scenarios"
                    :items="arg_making_scenarios"
                    item-text="value"
                    item-value="code"
                    @change="selectRow"
                    label="Policy-making Scenario"
                ></v-combobox>
                </v-col>
                <v-col cols="12" sm="6">
                <v-combobox
                    v-model="selected_arg_debt_scenarios"
                    :items="arg_debt_scenarios"
                    item-text="value"
                    item-value="code"
                    @change="selectRow"
                    label="Debt Scenarios"
                ></v-combobox>
                </v-col>
            </v-row>
            <div v-if="buenosAires_model">
                <v-row>
                    <v-col cols="6" sm="6">                        
                        <v-combobox
                            v-model="selected_macroeconomic_assumptions"
                            :items="pba_macroeconomic_assumptions"
                            item-text="value"
                            item-value="code"
                            @change="selectRow"
                            label="Macroeconomic Assumptions"
                        ></v-combobox>
                    </v-col>
                    <v-col cols="6" sm="6">
                        <v-combobox
                            v-model="selected_primary_balance_2020_2023"
                            :items="pba_primary_balance_2020_2023"
                            item-text="value"
                            item-value="code"
                            @change="selectRow"
                            label="Primary Balance 2020-2023"
                        ></v-combobox>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" sm="6">                        
                        <v-combobox
                            v-model="selected_primary_balance_target_2024"
                            :items="pba_primary_balance_target_2024"
                            item-text="value"
                            item-value="code"
                            @change="selectRow"
                            label="Primary Balance Target 2024+"
                        ></v-combobox>
                    </v-col>
                    <v-col cols="6" sm="6">
                        <v-combobox
                            v-model="selected_pba_debt_scenario"
                            :items="pba_debt_scenario"
                            item-text="value"
                            item-value="code"
                            @change="selectRow"
                            label="Debt Scenario Selection"
                        ></v-combobox>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" sm="6">                        
                        <v-combobox
                            v-model="selected_local_bonds_issued"
                            :items="pba_local_bonds_issued"
                            item-text="value"
                            item-value="code"
                            @change="selectRow"
                            label="% Local ARS Bonds Issued CPI-Linked"
                        ></v-combobox>
                    </v-col>
                </v-row>
            </div>
        </v-container>
        <v-dialog v-model="loading" fullscreen full-width>
            <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
              <v-layout justify-center align-center>
                <v-progress-circular
                    :size="50"
                    color="primary"
                    class="loading"
                    indeterminate
                    v-show="loading"
                ></v-progress-circular>
              </v-layout>
            </v-container>
        </v-dialog>
        <v-btn class="ma-2" outlined color="primary" 
            v-show="!hideRunModel"
            @click="runModel">Run model</v-btn>
        <div v-if="showPdf">
            <hr size="4" style="background: black;"/>
            <h1>Model Results</h1>
        </div>
        <PdfViewer 
            v-if="showPdf"
            v-bind:pdfArray="report"
            @close-pdfviewer="onPdfViewerClose"
            />
    </v-card>
</template>
<script>   
    import Documents from '@/api/documents'
    import PdfViewer from '@/components/PdfViewer.vue'
    import Vue from 'vue'
    
    export default {
        name: 'ModelViewer',
        props: {
            documentId: {
                type: Number,
                required: true
            },
            title: {
                type: String,
                required: true
            }
        },
        components:{
            PdfViewer
        },
        data() {
            return {
                hideRunModel:false,
                loading:false,
                showPdf:false,
                report:new Uint8Array(),
                valueChanged:false,                
                modelInfo:[],          
                
                //ecuador
                image_inputs_macro:"/img/Inputs_Macro_1_1.png",
                tabsInputsEcu: null,
                ecuInputTabs:[                    
                    {name:'Inputs Macro', tabId: '1'},
                    {name:'Inputs Refinancing', tabId: '3'},                  
                    {name:'Inputs Debt', tabId: '2'}
                ],
                selected_ecu_macro_scenarios:{value:'MoF (April)', code: 1},
                ecu_macro_scenarios:[
                    {value:'MoF (April)', code: 1},
                    {value:'IMF (May)', code: 2},
                    {value:'Downside Scenario (IMF Stress Scenario)', code: 3},
                    {value:'Upside Scenario', code: 4},
                ],
                selected_ecu_oil_scenarios:{value:'IMF (May)', code: 1},
                ecu_oil_scenarios:[
                    {value:'IMF (May)', code: 1},
                    {value:'Updated Oil Price Futures Curve', code: 2},
                ],
                ecu_refinancing_inputs_header:[
                    "",
                    "",
                    "2020",
                    "2021",
                    "2022",
                    "2023",
                    "2024",
                    "2025",
                    "2026",
                    "2027",
                    "2028",
                    "2029",
                    "2030",
                ],
                ecu_refinancing_inputs:[
                    {
                        title:"IMF Lending",
                        xxx_000_000_aux:"",
                        xxx_000_004_2020:"",
                        xxx_000_005_2021:"",
                        xxx_000_006_2022:"",
                        xxx_000_004_2023:"",
                        xxx_000_005_2024:"",
                        xxx_000_006_2025:"",
                        xxx_000_004_2026:"",
                        xxx_000_005_2027:"",
                        xxx_000_006_2028:"",
                        xxx_000_004_2029:"",
                        xxx_000_005_2030:""
                    },
                    {
                        name:"Type of Lending Program",
                        lbl_000_000_aux:"EFF",
                        xxx_000_004_2020:"",
                        xxx_000_005_2021:"",
                        xxx_000_006_2022:"",
                        xxx_000_004_2018:"",
                        xxx_000_005_2024:"",
                        xxx_000_006_2025:"",
                        xxx_000_004_2026:"",
                        xxx_000_005_2027:"",
                        xxx_000_006_2028:"",
                        xxx_000_004_2029:"",
                        xxx_000_005_2030:""
                    },
                    {
                        name:"Disbursement in 2021",
                        int_019_003_aux:"2000",
                        xxx_000_004_2019:"",
                        xxx_000_005_2021:"",
                        xxx_000_006_2022:"",
                        xxx_000_004_2019:"",
                        xxx_000_005_2024:"",
                        xxx_000_006_2025:"",
                        xxx_000_004_2026:"",
                        xxx_000_005_2027:"",
                        xxx_000_006_2028:"",
                        xxx_000_004_2029:"",
                        xxx_000_005_2030:""
                    },
                    {
                        title:"Other IFIs Lending",
                        xxx_000_000_aux:"",
                        xxx_000_004_2020:"",
                        xxx_000_005_2021:"",
                        xxx_000_006_2022:"",
                        xxx_000_004_2021:"",
                        xxx_000_005_2024:"",
                        xxx_000_006_2025:"",
                        xxx_000_004_2026:"",
                        xxx_000_005_2027:"",
                        xxx_000_006_2028:"",
                        xxx_000_004_2029:"",
                        xxx_000_005_2030:""
                    },
                    {
                        name:"Refinancing Rate",
                        xxx_000_000_aux:"",
                        per_022_004_aux:"2.6",
                        xxx_000_005_2021:"",
                        xxx_000_006_2022:"",
                        xxx_000_004_2022:"",
                        xxx_000_005_2024:"",
                        xxx_000_006_2025:"",
                        xxx_000_004_2026:"",
                        xxx_000_005_2027:"",
                        xxx_000_006_2028:"",
                        xxx_000_004_2029:"",
                        xxx_000_005_2030:""
                    },
                    {
                        name:"Rollover Rate",
                        xxx_000_000_aux:"",
                        per_023_004_2020:"100",
                        per_023_005_2021:"100",
                        per_023_006_2022:"100",
                        per_023_007_2023:"100",
                        per_023_008_2024:"100",
                        per_023_009_2025:"100",
                        per_023_010_2026:"100",
                        per_023_011_2027:"100",
                        per_023_012_2028:"100",
                        per_023_013_2029:"100",
                        per_023_014_2030:"100"
                    },
                    {
                        name:"New Money",
                        xxx_000_000_aux:"",
                        int_024_004_2020:"870",
                        int_024_005_2021:"0",
                        int_024_006_2022:"0",
                        int_024_007_2023:"0",
                        int_024_008_2024:"0",
                        int_024_009_2025:"0",
                        int_024_010_2026:"0",
                        int_024_011_2027:"0",
                        int_024_012_2028:"0",
                        int_024_013_2029:"0",
                        int_024_014_2030:"0"
                    },
                    {
                        title:"Bilateral Lending",
                        xxx_000_000_aux:"",
                        xxx_000_004_2020:"",
                        xxx_000_005_2021:"",
                        xxx_000_006_2022:"",
                        xxx_000_004_2021:"",
                        xxx_000_005_2024:"",
                        xxx_000_006_2025:"",
                        xxx_000_004_2026:"",
                        xxx_000_005_2027:"",
                        xxx_000_006_2028:"",
                        xxx_000_004_2029:"",
                        xxx_000_005_2030:""
                    },
                    {
                        name:"Refinancing Rate",
                        xxx_000_000_aux:"",
                        per_027_004_aux:"5.7",
                        xxx_000_005_2021:"",
                        xxx_000_006_2022:"",
                        xxx_000_004_2022:"",
                        xxx_000_005_2024:"",
                        xxx_000_006_2025:"",
                        xxx_000_004_2026:"",
                        xxx_000_005_2027:"",
                        xxx_000_006_2028:"",
                        xxx_000_004_2029:"",
                        xxx_000_005_2030:""
                    },
                    {
                        name:"Rollover Rate",
                        xxx_000_000_aux:"",
                        per_028_004_2020:"100",
                        per_028_005_2021:"100",
                        per_028_006_2022:"100",
                        per_028_007_2028:"100",
                        per_028_008_2024:"100",
                        per_028_009_2025:"100",
                        per_028_010_2026:"100",
                        per_028_011_2027:"100",
                        per_028_012_2028:"100",
                        per_028_013_2029:"100",
                        per_028_014_2030:"100"
                    },
                    {
                        name:"New Money",
                        xxx_000_000_aux:"",
                        int_029_004_2020:"0",
                        int_029_005_2021:"0",
                        int_029_006_2022:"0",
                        int_029_007_2023:"0",
                        int_029_008_2029:"0",
                        int_029_009_2025:"0",
                        int_029_010_2026:"0",
                        int_029_011_2027:"0",
                        int_029_012_2028:"0",
                        int_029_013_2029:"0",
                        int_029_014_2030:"0"
                    },
                    {
                        title:"Domestic Debt: CETES",
                        xxx_000_000_aux:"",
                        xxx_000_004_2020:"",
                        xxx_000_005_2021:"",
                        xxx_000_006_2022:"",
                        xxx_000_004_2021:"",
                        xxx_000_005_2024:"",
                        xxx_000_006_2025:"",
                        xxx_000_004_2026:"",
                        xxx_000_005_2027:"",
                        xxx_000_006_2028:"",
                        xxx_000_004_2029:"",
                        xxx_000_005_2030:""
                    },
                    {
                        name:"Refinancing Rate",
                        xxx_000_000_aux:"",
                        per_032_004_aux:"1.0",
                        xxx_000_005_2021:"",
                        xxx_000_006_2022:"",
                        xxx_000_004_2022:"",
                        xxx_000_005_2024:"",
                        xxx_000_006_2025:"",
                        xxx_000_004_2026:"",
                        xxx_000_005_2027:"",
                        xxx_000_006_2028:"",
                        xxx_000_004_2029:"",
                        xxx_000_005_2030:""
                    },
                    {
                        name:"Refinancing Tenor (years)",
                        xxx_000_000_aux:"",
                        int_033_004_aux:"1",
                        xxx_000_005_2021:"",
                        xxx_000_006_2022:"",
                        xxx_000_004_2022:"",
                        xxx_000_005_2024:"",
                        xxx_000_006_2025:"",
                        xxx_000_004_2026:"",
                        xxx_000_005_2027:"",
                        xxx_000_006_2028:"",
                        xxx_000_004_2029:"",
                        xxx_000_005_2030:""
                    },
                    {
                        name:"Rollover Rate (incl. interests)",
                        xxx_000_000_aux:"",
                        per_034_004_2020:"100",
                        per_034_005_2021:"100",
                        per_034_006_2022:"100",
                        per_034_007_2034:"100",
                        per_034_008_2024:"100",
                        per_034_009_2025:"100",
                        per_034_010_2026:"100",
                        per_034_011_2027:"100",
                        per_034_012_2034:"100",
                        per_034_013_2029:"100",
                        per_034_014_2030:"100"
                    },
                    {
                        title:"Domestic Debt: Bonds",
                        xxx_000_000_aux:"",
                        xxx_000_004_2020:"",
                        xxx_000_005_2021:"",
                        xxx_000_006_2022:"",
                        xxx_000_004_2021:"",
                        xxx_000_005_2024:"",
                        xxx_000_006_2025:"",
                        xxx_000_004_2026:"",
                        xxx_000_005_2027:"",
                        xxx_000_006_2028:"",
                        xxx_000_004_2029:"",
                        xxx_000_005_2030:""
                    },
                    {
                        name:"Refinancing Rate",
                        xxx_000_000_aux:"",
                        per_037_004_aux:"6.0",
                        xxx_000_005_2021:"",
                        xxx_000_006_2022:"",
                        xxx_000_004_2022:"",
                        xxx_000_005_2024:"",
                        xxx_000_006_2025:"",
                        xxx_000_004_2026:"",
                        xxx_000_005_2027:"",
                        xxx_000_006_2028:"",
                        xxx_000_004_2029:"",
                        xxx_000_005_2030:""
                    },
                    {
                        title:"International Reserves",
                        xxx_000_000_aux:"",
                        xxx_000_004_2020:"",
                        xxx_000_005_2021:"",
                        xxx_000_006_2022:"",
                        xxx_000_004_2021:"",
                        xxx_000_005_2024:"",
                        xxx_000_006_2025:"",
                        xxx_000_004_2026:"",
                        xxx_000_005_2027:"",
                        xxx_000_006_2028:"",
                        xxx_000_004_2029:"",
                        xxx_000_005_2030:""
                    },
                    {
                        name:"Target (% GDP)",
                        xxx_000_000_aux:"",
                        per_040_004_aux:"5.0",
                        xxx_000_005_2021:"",
                        xxx_000_006_2022:"",
                        xxx_000_004_2022:"",
                        xxx_000_005_2024:"",
                        xxx_000_006_2025:"",
                        xxx_000_004_2026:"",
                        xxx_000_005_2027:"",
                        xxx_000_006_2028:"",
                        xxx_000_004_2029:"",
                        xxx_000_005_2030:""
                    }
                ],
                ecu_debt_inputs_header:[
                    "",
                    "",
                    "New 2027 Bond",
                    "New 2030 Bond",
                    "New 2035 Bond",
                    "New 2040 Bond",                    
                    "Total",
                ],
                ecu_debt_inputs:[
                    {
                        title:"Issuance Date",
                        lbl_000_000_aux:"27/8/2020",
                        xxx_000_004_2027:"",
                        xxx_000_005_2030:"",
                        xxx_000_006_2035:"",
                        xxx_000_004_2040:"",
                        xxx_000_004_total:""
                    },
                    {
                        title:"First Coupon Date",
                        lbl_000_000_aux:"27/2/2021",
                        xxx_000_004_2027:"",
                        xxx_000_005_2030:"",
                        xxx_000_006_2035:"",
                        xxx_000_004_2040:"",
                        xxx_000_004_total:""
                    },
                    {
                        title:"Issuance (Before Principal Haircut)",
                        xxx_000_000_aux:"",
                        int_011_005_2027:"1800",
                        int_011_006_2030:"1800",
                        int_011_007_2035:"7375",
                        int_011_008_2040:"6400",
                        cal_011_009_total:"17375"
                    },
                    {
                        title:"Year of Maturity",
                        xxx_000_000_aux:"",
                        int_012_005_2027:"2027",
                        int_012_006_2030:"2030",
                        int_012_007_2035:"2035",
                        int_012_008_2040:"2040",
                        xxx_011_009_total:""
                    },
                    {
                        title:"Principal",
                        xxx_000_000_aux:"",
                        int_013_005_2027:"100.0",
                        int_013_006_2030:"100.0",
                        int_013_007_2035:"100.0",
                        int_013_008_2040:"100.0",
                        xxx_013_009_total:""
                    },
                    {
                        title:"# of semiannual amortizations",
                        xxx_000_000_aux:"",
                        int_014_005_2027:"8.0",
                        int_014_006_2030:"6.0",
                        int_014_007_2035:"10.0",
                        int_014_008_2040:"20.0",
                        xxx_013_009_total:""
                    },
                    /*{
                        title:"Treatment of Accrued Interest",
                        int_015_003_aux:"0",
                        xxx_000_004_2027:"",
                        xxx_000_005_2030:"",
                        xxx_000_006_2035:"",
                        xxx_000_004_2040:"",
                        xxx_000_004_total:""
                    },*/
                    {
                        title:"Coupon Strip",
                        xxx_000_000_aux:"",
                        xxx_000_004_2027:"",
                        xxx_000_005_2030:"",
                        xxx_000_006_2035:"",
                        xxx_000_004_2040:"",
                        xxx_000_004_total:""
                    },
                    {
                        name:"2020",
                        xxx_000_000_aux:"",
                        per_017_005_2027:"0.00",
                        per_017_006_2030:"0.00",
                        per_017_007_2035:"0.00",
                        per_017_008_2040:"0.00",
                        xxx_017_009_total:""
                    },
                    {
                        name:"2021",
                        xxx_000_000_aux:"",
                        per_018_005_2027:"0.50",
                        per_018_006_2030:"0.50",
                        per_018_007_2035:"0.50",
                        per_018_008_2040:"0.50",
                        xxx_000_009_total:""
                    },
                    {
                        name:"2022",
                        xxx_000_000_aux:"",
                        per_019_005_2027:"1.00",
                        per_019_006_2030:"2.00",
                        per_019_007_2035:"2.25",
                        per_019_008_2040:"2.25",
                        xxx_000_009_total:""
                    },
                    {
                        name:"2023",
                        xxx_000_000_aux:"",
                        per_020_005_2027:"1.50",
                        per_020_006_2030:"3.50",
                        per_020_007_2035:"3.75",
                        per_020_008_2040:"3.75",
                        xxx_000_009_total:""
                    },
                    {
                        name:"2024",
                        xxx_000_000_aux:"",
                        per_021_005_2027:"2.50",
                        per_021_006_2030:"4.75",
                        per_021_007_2035:"5.00",
                        per_021_008_2040:"5.00",
                        xxx_000_009_total:""
                    },
                    {
                        name:"2025",
                        xxx_000_000_aux:"",
                        per_022_005_2027:"3.50",
                        per_022_006_2030:"6.75",
                        per_022_007_2035:"7.75",
                        per_022_008_2040:"7.75",
                        xxx_000_009_total:""
                    },
                    {
                        name:"2026",
                        xxx_000_000_aux:"",
                        per_023_005_2027:"3.50",
                        per_023_006_2030:"6.75",
                        per_023_007_2035:"7.75",
                        per_023_008_2040:"7.75",
                        xxx_000_009_total:""
                    },
                    {
                        name:"2027",
                        xxx_000_000_aux:"",
                        per_024_005_2027:"3.50",
                        per_024_006_2030:"6.75",
                        per_024_007_2035:"7.75",
                        per_024_008_2040:"7.75",
                        xxx_000_009_total:""
                    },
                    {
                        name:"2028",
                        xxx_000_000_aux:"",
                        per_025_005_2027:"3.50",
                        per_025_006_2030:"6.75",
                        per_025_007_2035:"7.75",
                        per_025_008_2040:"7.75",
                        xxx_000_009_total:""
                    },
                    {
                        name:"2029",
                        xxx_000_000_aux:"",
                        per_026_005_2027:"3.50",
                        per_026_006_2030:"6.75",
                        per_026_007_2035:"7.75",
                        per_026_008_2040:"7.75",
                        xxx_000_009_total:""
                    },
                    {
                        name:"2030",
                        xxx_000_000_aux:"",
                        per_027_005_2027:"3.50",
                        per_027_006_2030:"6.75",
                        per_027_007_2035:"7.75",
                        per_027_008_2040:"7.75",
                        xxx_000_009_total:""
                    },
                    {
                        name:"2031, onwards",
                        xxx_000_000_aux:"",
                        per_028_005_2027:"3.50",
                        per_028_006_2030:"6.75",
                        per_028_007_2035:"8.75",
                        per_028_008_2040:"8.75",
                        xxx_000_009_total:""
                    }
                ],
                ecu_debt_inputs_total_issuance:0,

                //argentina
                selected_arg_making_scenarios:{value:'IMF DSA', code: 4},
                arg_making_scenarios:[
                    {value:'IMF DSA', code: 4},
                    {value:'Argentina DSA', code: 6},
                    {value:'Argentina DSA (2% US CPI)', code: 7},
                    {value:'Argentina DSA (upper case parametrization)', code: 5},
                    {value:'Our DSA', code: 2}
                ],
                selected_arg_debt_scenarios:{value:'Argentina Proposal', code: 3},
                arg_debt_scenarios:[
                    {value:'Argentina Proposal', code: 3},
                    {value:'Bondholders Proposal', code: 4}
                ],

                //buenos aires
                selected_macroeconomic_assumptions:{value:'Baseline Budget', code: 2},
                pba_macroeconomic_assumptions:[
                    {value:'Bullish', code: 1},
                    {value:'Baseline Budget', code: 2},
                    {value:'Bearish', code: 3}
                ],
                selected_primary_balance_2020_2023:{value:'PBA Budget', code: 1},
                pba_primary_balance_2020_2023:[
                    {value:'PBA Budget', code: 1},
                    {value:'PBA Budget with Halved Real Capex Increase', code: 2},
                    {value:'PBA Budget with Increased COPA Share 2022+ (in two yearly steps)', code: 3},
                    {value:'PBA Budget with Halved Real Capex Increase & Increased COPA Share 2022+', code: 4}
                ],
                selected_primary_balance_target_2024 :{value:'0.4% 2024+', code: 1},
                pba_primary_balance_target_2024:[
                    {value:'0.4% 2024+', code: 1},
                    {value:'0.4% 2024, 0.5% 2025+', code: 2},
                    {value:'0.4% 2024, 0.5% 2025 & 0.6% 2026+', code: 3}
                ],
                selected_pba_debt_scenario :{value:'Altenative A', code: 1},
                pba_debt_scenario:[
                    {value:'Altenative A', code: 1},
                    {value:'Altenative B', code: 2},
                    {value:'Altenative C (Strawman)', code: 3}
                ],
                selected_local_bonds_issued :{value:'0% of total', code: 1},
                pba_local_bonds_issued:[
                    {value:'0% of total', code: 1},
                    {value:'25% of total', code: 2},
                    {value:'50% of total', code: 3}
                ]
            }
        },
        computed:{
            arg_model(){
                if(this.documentId==3)
                {
                    return true;
                }else{
                    return false;
                }
            },
            ecu_model(){
                if(this.documentId==4)
                {
                    return true;
                }else{
                    return false;
                }
            },
            buenosAires_model(){
                if(this.title=='Province of Buenos Aires Debt - DSA Model')
                {
                    return true;
                }else{
                    return false;
                }
            }
        },
        methods:{
        calculate_total(value){       
            this.ecu_debt_inputs_total_issuance = Number(value.int_011_005_2027)+ Number(value.int_011_006_2030)+ Number(value.int_011_007_2035)+ Number(value.int_011_008_2040)     
            
            return this.ecu_debt_inputs_total_issuance
        },
        selectRow(){
            this.valueChanged = true;
            this.showPdf = false;
            if(this.selected_ecu_macro_scenarios.code>0 
                && this.selected_ecu_oil_scenarios.code>0)
            {                
                this.image_inputs_macro="/img/Inputs_Macro_"+
                    this.selected_ecu_macro_scenarios.code+"_"+
                    + this.selected_ecu_oil_scenarios.code +".png";
            }   
        },
        typeField(field){
            return field.substring(0,1)
        },
        closeModelViewer(){
            this.$emit('close-modelviewer','true');
        },
        onPdfViewerClose(){ 
            this.showPdf=false;
            this.hideRunModel=false;
        },
        load_inputs(modelInfo, inputs, sheetName){
            var result = true
            var keys=['int','per']
            _.forEach(inputs, function(input) {
                _.forEach(input, function(value,key) {
                    if (_.includes(keys,key.substring(0,3))){
                        if(isNaN(Number(value)))
                        {
                            result = false;
                            Vue.notify({
                                group: 'general',
                                type: 'error',
                                text: 'You must enter only numeric values.'
                            })
                        }
                        var itemValue = Number(value)
                        if(key.substring(0,3)=="per"){
                            itemValue = itemValue /100
                        }

                        var item={
                            "sheetName":sheetName,
                            "rowNumber":Number(key.substring(4,7)),
                            "columnNumber":Number(key.substring(8,11)),
                            "value":itemValue
                        }
                    }
                })
            });
            return result
        },
        load_model(){
            if(this.ecu_model){
                this.modelInfo={
                    "email":this.$store.getters.getUser.email,
                    "document_id":this.documentId,
                    "listSheets":["Output"],
                    "listEditCells":[
                        {
                            "sheetName":"Inputs_Macro",
                            "rowNumber":6,
                            "columnNumber":3,
                            "value":this.selected_ecu_macro_scenarios.code
                        },
                        {
                            "sheetName":"Inputs_Macro",
                            "rowNumber":12,
                            "columnNumber":3,
                            "value":this.selected_ecu_oil_scenarios.code
                        }
                    ]
                }
                if(this.ecu_debt_inputs_total_issuance >17375)
                {                    
                    Vue.notify({
                        group: 'general',
                        type: 'error',
                        text: "'Issuance' bonds Total within 'Input-Debt' must be equal to USD 17,375"
                        })
                    return false
                }
                return (this.load_inputs(this.modelInfo, this.ecu_refinancing_inputs,"Inputs_Refinancing")
                    &&  this.load_inputs(this.modelInfo, this.ecu_debt_inputs,"Input_Debt"))
            }
            if(this.arg_model){
                this.modelInfo={
                    "email":this.$store.getters.getUser.email,
                    "document_id":this.documentId,
                    "listSheets":["Output"],
                    "listEditCells":[
                        {
                            "sheetName":"Control Panel",
                            "rowNumber":6,
                            "columnNumber":5,
                            "value":this.selected_arg_making_scenarios.code
                        },
                        {
                            "sheetName":"Control Panel",
                            "rowNumber":65,
                            "columnNumber":6,
                            "value":this.selected_arg_debt_scenarios.code
                        }
                    ]
                }                
            }
            if(this.buenosAires_model){
                this.modelInfo={
                    "email":this.$store.getters.getUser.email,
                    "document_id":this.documentId,
                    "listSheets":["Output"],
                    "listEditCells":[
                        {
                            "sheetName":"Inputs",
                            "rowNumber":6,
                            "columnNumber":4,
                            "value":this.selected_macroeconomic_assumptions.code
                        },
                        {
                            "sheetName":"Inputs",
                            "rowNumber":10,
                            "columnNumber":4,
                            "value":this.selected_primary_balance_2020_2023.code
                        },
                        {
                            "sheetName":"Inputs",
                            "rowNumber":15,
                            "columnNumber":4,
                            "value":this.selected_primary_balance_target_2024.code
                        },
                        {
                            "sheetName":"Inputs",
                            "rowNumber":19,
                            "columnNumber":4,
                            "value":this.selected_pba_debt_scenario.code
                        },
                        {
                            "sheetName":"Inputs",
                            "rowNumber":23,
                            "columnNumber":4,
                            "value":this.selected_local_bonds_issued.code
                        }
                    ]
                }                
            }
            return true
        },
        runModel(){
            const vm = this
            if(vm.load_model()) {
                vm.loading=true;
                return new Promise((resolve, reject) => {
                    Documents.runModel(vm.modelInfo).then(
                        data => {
                            var raw =atob(data) 
                            var rawLength = raw.length;
                            var array = new Uint8Array(new ArrayBuffer(rawLength));

                            for(var i = 0; i < rawLength; i++) {
                                array[i] = raw.charCodeAt(i);
                            }
                            vm.report = array;
                            vm.loading = false;
                            
                            vm.showPdf = true;
                        }
                    )
                })
            }
        }
    }
}
</script>
<style scoped>
    h1 {
      font-weight: 600;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
      text-align: left;
      color: black;
    }
    h5{
        font-weight: 400;
    }
    .cell{
        height: 15px;
        font-size: smaller !important;        
        text-align: center;
        font-weight: 400;
    }
    .cell_left{
        height: 15px;
        font-size: smaller;        
        text-align: left;
        font-weight: 600;
    }
    .cell_left_pad{
        height: 15px;
        font-size: smaller;        
        text-align: left;
        font-weight: 400;
        padding-left: 20px;
    }
    .class_header{        
        background-color: #234AB3;
        color: white;
        padding-bottom: 0px;
        padding-top: 0px;
        height: 40px;
    }    
    .btn_back{  
        top: 0px;
        left: 5px;
        margin-top: 80px;
    }
</style>